import { FC, useEffect, useRef } from "react";
import { buildASOPath, buildClockworkWebPath } from "lib/resource-finder";
import { useGetMemberPermissionsQuery } from "types/generated/operations";

const PeopleAnalytics: FC = () => {
  const { data, loading, error } = useGetMemberPermissionsQuery();
  const didRedirect = useRef(false);

  useEffect(() => {
    if (loading || didRedirect.current) return;
    if (!data && !error) return;

    didRedirect.current = true;
    const cdmsId =
      data?.authenticatedMember?.company?.cdmsCanonicalCompanyId ?? "";
    const url = cdmsId
      ? buildASOPath(`/company/${cdmsId}/reports`)
      : buildClockworkWebPath("/reports");
    window.location.assign(url);
  }, [loading, data, error]);

  return null;
};

export default PeopleAnalytics;
